import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/SkipToContent/skip-to-content';
import buttonStyles from '@patternfly/react-styles/css/components/Button/button';
import { css } from '@patternfly/react-styles';
export var SkipToContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SkipToContent, _React$Component);

  function SkipToContent() {
    var _this;

    _classCallCheck(this, SkipToContent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SkipToContent).apply(this, arguments));
    _this.componentRef = React.createRef();
    return _this;
  }

  _createClass(SkipToContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.show && this.componentRef.current) {
        this.componentRef.current.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = this.props,
          children = _a.children,
          className = _a.className,
          href = _a.href,
          show = _a.show,
          type = _a.type,
          rest = __rest(_a, ["children", "className", "href", "show", "type"]);

      return React.createElement("a", Object.assign({}, rest, {
        className: css(buttonStyles.button, buttonStyles.modifiers.primary, styles.skipToContent, className),
        ref: this.componentRef,
        href: href
      }), children);
    }
  }]);

  return SkipToContent;
}(React.Component);
SkipToContent.defaultProps = {
  show: false
};